module.exports = __webpack_public_path__ + "img/skull_12.5488205d.png";